// extracted by mini-css-extract-plugin
export default {"zoomControls":"Nba-z","zoomControlButton":"Oba-z","zoomBanner":"Pba-z","bannerButton":"Qba-z","imageButton":"Rba-z","zoom":"Sba-z","zoomContent":"Tba-z"};